import React, { useState } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { isFieldEmpty } from "@limitless/common/utils";
import FramedContentContainer from "../../containers/framed-content-container/FramedContentContainer";
import OkCancelDialog from "../ok-cancel-dialog/OkCancelDialog";
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
const NewFieldDialog = ({
  classes,
  fieldName,
  onCancel,
  onSave,
  dialogBody,
  dialogValidate,
  title,
  value
}) => {
  const [field, setField] = useState(value);
  const {
    fieldErrors
  } = dialogValidate && dialogValidate({
    [fieldName.toLowerCase()]: {
      value: field
    }
  });
  title = title === "" ? `Create a New ${fieldName}` : title;
  return /*#__PURE__*/React.createElement(OkCancelDialog, {
    title: title,
    okLabel: "Save",
    okId: "save",
    onCancelClick: onCancel,
    onOKClick: () => onSave(field),
    dialogProps: {
      onBackdropClick: onCancel
    },
    dialogTitleProps: {
      classes: {
        root: classes.dialog
      }
    },
    okDisabled: isFieldEmpty(field) || fieldErrors[fieldName.toLowerCase()] !== ""
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, dialogBody), /*#__PURE__*/React.createElement(FramedContentContainer, {
    title: "",
    disableMinHeight: true,
    showBorder: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textInputContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(PortalTextInput, {
    label: fieldName,
    onChange: event => {
      setField(event.target.value);
    },
    value: field,
    id: `${fieldName.toLowerCase()}NameInput`,
    variant: "outlined",
    fullWidth: true,
    placeholder: `Enter a ${fieldName.toLowerCase()} name`,
    autoFocus: true,
    isMandatory: true,
    inputProps: {
      className: classes.input
    },
    error: fieldErrors[fieldName.toLowerCase()] ? true : false,
    helperText: fieldErrors[fieldName.toLowerCase()]
  })))));
};
const styles = theme => ({
  title: {
    marginBottom: 16
  },
  textInputContainer: {
    justifyContent: "space-between",
    display: "flex",
    paddingTop: 0,
    backgroundColor: theme.background.default,
    padding: 8
  },
  dialog: {
    paddingBottom: 0
  },
  input: {
    fontSize: "0.875rem",
    backgroundColor: theme.background.paper
  },
  inputWrapper: {
    width: "100%"
  }
});
export default withStyles(styles)(NewFieldDialog);
NewFieldDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  dialogBody: PropTypes.string,
  dialogValidate: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.string
};
NewFieldDialog.defaultProps = {
  value: "",
  fieldName: "",
  dialogBody: "",
  title: ""
};